
export const BILLING_FAQ = [
  {
    q: 'Do you offer a free plan?',
    a: "Yes — the Free plan gives you access to the Studio, hundreds of AI voices, and all major features, no credit card required. It doesn't expire; use it as long as you stay within the plan limits.",
  },
  {
    q: 'Do I have commercial rights for the audio I create?',
    a: 'All paid plan customers have commercial rights over content created with Listen2It. The Free plan is for personal / evaluation use only.',
  },
  {
    q: 'How are credits counted?',
    a: "Credits are deducted based on the feature you use — see “How credits are used” above for the exact rate per feature (e.g. 1 credit per word for text-to-speech, 1,200 credits per minute for dubbing). Previewing audio in the Studio is unlimited and free.",
  },
  {
    q: 'What happens if I go over my plan limit?',
    a: "We'll notify you as you approach your limit and again when you hit it. You'll need to upgrade to keep generating — your limit refreshes automatically every billing period on a paid plan.",
  },
  {
    q: 'Can I change my plan?',
    a: 'Yes, anytime. On an upgrade, any unused payment is credited toward the new plan and you only pay the difference. Your limits update immediately.',
  },
  {
    q: 'Can I cancel my subscription?',
    a: "Yes, anytime from Plan & Billing. Your plan won't renew for the next cycle and you won't be charged again — you keep full access until the end of your current billing period.",
  },
  {
    q: 'What payment types are accepted?',
    a: 'All major credit cards and any method supported by our payment processor in your country.',
  },
  {
    q: 'Do you offer custom or Enterprise plans?',
    a: 'Yes — for large-scale needs we offer custom credit volumes, integrations, audio advertising, and volume-based pricing. Get in touch with our team for a quote.',
  },
  {
    q: 'What is the Starter $5 intro offer?',
    a: 'New users get the full Starter plan for $5 in their first month. From month 2 it renews at the regular $19/month — cancel anytime before renewal to avoid the charge.',
  },
];
